var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 114,
    viewBox: "0 0 127 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5593 109.889C37.5753 101.455 42.0555 93.5131 47.1748 85.6995C50.5058 80.6153 51.0697 79.4585 45.8712 74.9809C31.5794 62.6712 7.65687 56.5099 3.93829 35.438C-1.4888 4.68445 50.86 3.10649 69.481 4.65824C92.6002 6.58484 128.844 14.6933 122.35 44.9978C118.657 62.2303 107.189 72.9869 89.7594 73.3876C79.8124 73.6162 67.3681 69.5478 60.7903 78.2399C54.9083 86.0125 50.518 92.542 42.8294 98.7356C39.7946 101.18 36.3705 107.281 32.2556 107.281",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.833959990df0190fb784ab25639588ff.svg";
export { ForwardRef as ReactComponent };